import React, { useState, useEffect } from 'react';
import styles from './styles.module.css';
import QRCOde from 'qrcode.react';
import { useSelector, useDispatch } from 'react-redux';
import { checkInBtn, whiteCloseIcon, wrench, bellDot } from 'assets/newIcons';
import { Box, Drawer } from '@material-ui/core';
import StatusPopup from 'components/shared/StatusPopup';

const boxStyle = {
  height: '100vh',
  padding: '60px 20px 0px 10px',
  backgroundImage: 'linear-gradient(180deg, #ff5000 62.5%, rgba(254, 80, 0, 0.68) 100%)',
};

export default function CheckInQR() {
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [isCheckInPausedPopupOpen, setCheckInPausedPopupOpen] = useState(false);
  const qrCodeDetails = useSelector(state => state?.homePageNew?.qrCodeDetails);
  const dispatch = useDispatch();
  const [codeForQr, setCodeForQr] = useState(qrCodeDetails?.data);
  const profile = useSelector(state => state?.auth?.profile);
  const caId = profile?.userID;
  const termsAgreementDetails = useSelector(
    state => state?.termsAndConditions?.termsAgreementDetails
  );
  const enableQR = termsAgreementDetails?.enableQR;
  const isProfileLoaded = Object.keys(profile || {}).length > 0;
  const isConfigLoaded = Object.keys(termsAgreementDetails || {}).length > 0;
  const toggleDrawer = () => {
    setDrawerOpen(!isDrawerOpen);
  };

  const handleCheckInClick = () => {
    if (!isProfileLoaded || !isConfigLoaded) {
      return;
    }
    if (enableQR === false) {
      setCheckInPausedPopupOpen(true);
    } else {
      toggleDrawer();
    }
  };

  useEffect(() => {
    setCodeForQr(qrCodeDetails?.data);
  }, [qrCodeDetails]);

  useEffect(() => {
    let intervalId;
    if (caId && isDrawerOpen) {
      const fetchQrCode = () => {
        dispatch({
          type: 'LOAD_QR_CODE_REQUEST',
          caId,
        });
      };
      fetchQrCode(); // Initial call
      intervalId = setInterval(fetchQrCode, 5000);
    }
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [caId, dispatch, isDrawerOpen]);

  return (
    <div>
      <img
        alt=""
        src={checkInBtn}
        onClick={handleCheckInClick}
        className={styles.fixedButton}
        style={
          !isProfileLoaded || !isConfigLoaded
            ? { opacity: 0.5, pointerEvents: 'none' }
            : undefined
        }
      />
      <Drawer anchor="bottom" open={isDrawerOpen} onClose={() => toggleDrawer()}>
        <Box sx={boxStyle}>
          <div className={styles.imgContainer}>
            <img
              alt=""
              onClick={() => toggleDrawer()}
              className={styles.closeIcon}
              src={whiteCloseIcon}
            />
          </div>
          {qrCodeDetails && Object.keys(qrCodeDetails).length > 0 ? (
            codeForQr ? (
              <div className={styles.content}>
                <p>
                  Scan this QR Code at the front <br /> desk to check-in.
                </p>
                {codeForQr && (
                  <div className={styles.codeSection}>
                    <QRCOde className={styles.code} value={codeForQr} size={166} />
                  </div>
                )}
                <b>
                  Have a great <br /> workout!
                </b>
              </div>
            ) : (
              <div className={styles.content}>
                <p>{qrCodeDetails?.message}</p>
              </div>
            )
          ) : (
            <div className={styles.content}>
              <p>Loading...</p>
            </div>
          )}
        </Box>
      </Drawer>
      <StatusPopup
        open={isCheckInPausedPopupOpen}
        onClose={() => setCheckInPausedPopupOpen(false)}
        icon={wrench}
        iconAlt="Check-ins paused"
        title="CHECK-INS ARE PAUSED"
        description={`We're making some improvements behind the scenes to serve you better.\nYou won't be able to check in until the update is done. Nothing on your end needs fixing.`}
        notifyIcon={bellDot}
        notifyText="We'll notify you the moment it's back."
      />
    </div>
  );
}
